// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAWmEOMC4cNL4q0b7j1nNDjpgUb_cucOfA",
  authDomain: "personal-architect-neighborly.firebaseapp.com",
  projectId: "personal-architect-neighborly",
  storageBucket: "personal-architect-neighborly.firebasestorage.app",
  messagingSenderId: "1047626897431",
  appId: "1:1047626897431:web:fbd1b2245bd6ebf2742452"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);